import { Dialog } from "@headlessui/react";
import { useEffect, useMemo, useState } from "react";
import Button from "../basic/Button";
import ic_close from "../../assets/icons/ic_close.svg";
import IconButton from "../basic/IconButton";
import CustomDialog from "../basic/Dialog";
import {
  BlueTextLinearGradient,
  capitalize,
  WhiteLinearGradient,
} from "../../utils/Utils";
import ic_calories from "../../assets/icons/ic_calories.svg";
import { MemoizedExerciseList } from "./Exercise";
import { Icon } from "@iconify/react";
import {
  addMultipleExercisesToPlaylist,
  createUserPlaylist,
} from "../../api/api";
import { toast } from "react-toastify";
import useIsMobile from "../../utils/useIsMobile";

export function ExerciseCard({
  id,
  exerciseName,
  exerciseImage,
  onClick,
  selected,
}) {
  return (
    <div
      className={`${
        selected ? "border-2 border-primary-neonGreen" : ""
      } group w-full min-h-[200px] rounded-xl overflow-clip max-h-full flex flex-1 justify-center items-center  z-0`}
    >
      <div
        className={`transform w-full h-full bg-gray-900  transition-all rounded-xl`}
      >
        <img
          src={exerciseImage}
          className="absolute h-full object-cover w-full"
        />
        <div
          className={`h-full relative bg-cover ${
            selected ? "bg-black-300 bg-opacity-90" : ""
          } overflow-clip rounded-xl flex justify-center items-center flex-col `}
          onClick={onClick}
        >
          <div className="bg-black bg-opacity-60 p-2 md:p-4 h-full w-full flex flex-col rounded-xl">
            <div className="flex w-full self-end items-center gap-2">
              {/* <img src={ic_calories} />
              <p className="text-white text-sm">317 kCal</p> */}
              <div className="flex-1" />
            </div>
            <div className="flex flex-1 items-end  w-full">
              <div className="flex w-full items-center">
                <p
                  className={`font-bold font-poppins text-xl md:text-2xl text-white flex flex-1 items-end`}
                >
                  {capitalize(exerciseName)}
                </p>
                {/* <Icon
                  icon="mdi:cards-heart"
                  className="flex  md:h-6 md:w-6 text-red-500 "
                  onClick={(e) => { }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SelectedExercise({ exerciseName, exerciseImage }) {
  return (
    <div className="w-full flex flex-row justify-center items-center space-x-4 py-2">
      <img src={exerciseImage} className="h-14 w-24 object-cover rounded-lg" />
      <p className="font-open-sans text-lg text-black dark:text-primary-white flex flex-1 ">
        {exerciseName}
      </p>
    </div>
  );
}
function CreateRoutineDialog({ open, close, exercises }) {
  const [showNameDialog, setShowNameDialog] = useState(false);
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [routineName, setRoutineName] = useState("");
  const getExercise = (id) => {
    let exercise = {};
    Object.keys(exercises).map((category, categoryIndex) => {
      exercises[category].forEach((ex) => {
        if (ex.id === id) {
          exercise = ex;
          return exercise;
        }
      });
    });
    return exercise;
  };
  const [expanded, setExpanded] = useState(false);
  const isMobile = useIsMobile();
  const createRoutine = async () => {
    const response = await createUserPlaylist(routineName);
    if (response.success) {
      const res = await addMultipleExercisesToPlaylist(
        response.playlistName,
        JSON.stringify(selectedExercises)
      );
      if (res.success) {
        setShowNameDialog(false);
        toast("Routine Created", { type: "success" });
        setSelectedExercises([]);
        close();
      } else {
        toast("Routine Addition failed", { type: "error" });
      }
    } else {
      toast("Error creating routine", { type: "error" });
    }
  };

  return (
    <>
      <CustomDialog
        show={showNameDialog}
        close={() => {
          setShowNameDialog(false);
        }}
      >
        <Dialog.Panel
          className={`w-full relative max-w-sm transform  rounded-xl ${WhiteLinearGradient} p-6 text-left align-middle shadow-xl transition-all`}
        >
          <IconButton
            icon={ic_close}
            className="shadow-xl absolute -top-5 -right-5"
            onClick={() => {
              setShowNameDialog(false);
            }}
          />
          <p
            className={`font-poppins font-bold text-xl text-primary-black dark:text-white text-center w-full `}
          >
            Create a Routine
          </p>
          <input
            value={routineName}
            className={`mt-3 px-4 py-3 rounded-lg border-[1px] border-gray-300 w-full ${WhiteLinearGradient} text-black dark:text-white`}
            placeholder="Routine Name"
            onChange={(e) => {
              setRoutineName(e.target.value);
            }}
          />
          <div
            className="mt-5 rounded-full cursor-pointer px-5 py-2 text-center bg-primary-neonGreen"
            onClick={() => {
              if (routineName.length == 0) {
                toast("Playlist name is required", { type: "error" });
              } else {
                createRoutine();
              }
            }}
          >
            Create Routine
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <CustomDialog
        show={open}
        close={() => {
          setSelectedExercises([]);
          close();
        }}
      >
        <Dialog.Panel
          className={`w-full relative transform rounded-xl bg-black-100 text-left align-middle shadow-xl transition-all m-5`}
        >
          <IconButton
            icon={ic_close}
            className="shadow-xl absolute -top-5 -right-2 "
            onClick={() => {
              setSelectedExercises([]);
              close();
            }}
          />
          <div className="w-full h-full flex flex-1 justify-center items-center overflow-clip rounded-xl">
            <div className="flex basis-2/3 flex-1 w-full p-6 flex-col max-h-screen overflow-y-scroll gap-5">
              <p className="font-poppins text-center w-full text-white font-bold text-3xl ">
                <span className="text-primary-neonGreen">Create</span>
                {"  "} your Routine
              </p>
              {exercises
                ? Object.keys(exercises).map((category, categoryIndex) => {
                    return (
                      <>
                        <p
                          className={`${BlueTextLinearGradient} font-poppins font-medium text-left text-2xl z-0`}
                        >
                          {category}
                        </p>
                        <div className="flex flex-row items-center space-x-4">
                          <div className="grid grid-cols-2 md:grid-cols-3   flex-1 gap-4 ">
                            {exercises[category].map((exercise, index) => {
                              return (
                                <ExerciseCard
                                  {...exercise}
                                  selected={selectedExercises.includes(
                                    exercise.id
                                  )}
                                  key={index}
                                  onClick={() => {
                                    if (
                                      selectedExercises.includes(exercise.id)
                                    ) {
                                      let list = [];
                                      selectedExercises.forEach((eid) => {
                                        if (eid != exercise.id) {
                                          list.push(eid);
                                        }
                                      });
                                      setSelectedExercises([...list]);
                                    } else {
                                      setSelectedExercises([
                                        ...selectedExercises,
                                        exercise.id,
                                      ]);
                                    }
                                  }}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </>
                    );
                  })
                : null}
            </div>
            {!isMobile ? (
              <div className="flex flex-col basis-1/3 bg-black-400 flex-1 h-screen gap-5 p-6">
                <p className="font-poppins text-center w-full text-white font-bold text-3xl ">
                  Selected Exercies
                </p>
                <div className="flex flex-1 h-full flex-col overflow-y-scroll">
                  {selectedExercises.map((exerciseId) => {
                    return <SelectedExercise {...getExercise(exerciseId)} />;
                  })}
                </div>
                <div
                  className="rounded-full cursor-pointer px-5 py-2 text-center bg-primary-neonGreen"
                  onClick={() => {
                    setShowNameDialog(true);
                  }}
                >
                  Create Routine
                </div>
              </div>
            ) : (
              <div className="flex flex-col absolute w-full bottom-0 left-0 bg-black-400 gap-5 p-6 rounded-xl">
                {expanded && (
                  <p className="font-poppins text-center w-full text-white font-bold text-xl ">
                    Selected Exercies
                  </p>
                )}
                {expanded && (
                  <div className="flex flex-1 h-full flex-col max-h-24 overflow-y-scroll">
                    {selectedExercises.map((exerciseId) => {
                      return <SelectedExercise {...getExercise(exerciseId)} />;
                    })}
                  </div>
                )}
                <p
                  className="font-poppins text-center w-full text-white text-sm "
                  onClick={() => {
                    setExpanded(!expanded);
                  }}
                >
                  {selectedExercises.length} Exercies selected |{" "}
                  {expanded ? "hide" : "view"} all
                </p>
                <div
                  className="rounded-full cursor-pointer px-5 py-2 text-center bg-primary-neonGreen"
                  onClick={() => {
                    setShowNameDialog(true);
                  }}
                >
                  Create Routine
                </div>
              </div>
            )}
          </div>
        </Dialog.Panel>
      </CustomDialog>
    </>
  );
}

export default CreateRoutineDialog;
